import { DocumentNode } from 'graphql';
import { ApolloQueryResult, useQuery } from '@apollo/client';

type ImperativeCallQuery = (variables: GenericMap) => Promise<ApolloQueryResult<any>>;

export const useImperativeQuery = (query: DocumentNode, extraConfig: GenericMap): ImperativeCallQuery => {
  const { refetch } = useQuery(query, { skip: true, ...extraConfig });
  const imperativelyCallQuery = (variables: GenericMap) => refetch(variables);
  return imperativelyCallQuery;
};
